import PropTypes from 'prop-types'
import ArtistDetail from './components/ArtistDetail'
import ModuleProvider from './provider/ModuleProvider'

/**
 * @returns {JSX.Element
 * @constructor
 */

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

function Artists(props) {
  return (
    //@ts-ignore
    <ModuleProvider CMSProps={props}>
      <ArtistDetail />
    </ModuleProvider>
  )
}

Artists.propTypes = {
  CMSProps: PropTypes.object
}

export default Artists